<template>
	<div class="activity">
		<div class="top">
			<img class="logo" src="../../static/img/logo.png" />
			<router-link class="back"  to="/login">
				返回首页
			</router-link>
		</div>
		<div class="center">
				<h5 class="tit">
					{{tit}}
				</h5>
				<ul class="con">
					<li class="tHead"><a><span>序号</span><span>牵头部门</span><span>活动名称</span><span>主要内容</span><span>时间地点</span><span>活动规模</span><span>联系人</span><span>联系电话</span></a></li>
					<li v-for="(item, index) in list" :key="index" >
						<a :href="item.link==''?'javascript:void(0);':item.link" :target="item.link ==''?'':'_blank'" :class="item.link==''?'color':'blue'">
							<span>{{index+1}}</span><span>{{item.department}}</span><span>{{item.name}}</span><span>{{item.content}}</span><span>{{item.place}}</span><span>{{item.scale}}</span><span>{{item.username}}</span><span>{{item.phone}}</span>
						</a>						
					</li>
				</ul>
				
		</div>
		<bottom></bottom>
	</div>
</template>

<script>
	import Qs from 'qs'
	import bottom from './Bottom'
  	export default {
  		components: {
			bottom
		},
	    data() {
		    return {
		    	tit:'',
		        list:[],
		    };
	    },
		created() {
	  	},
	  	mounted() {
	  		this.$axios({
				method: 'post',
				url: 'activity/datalist',
			}).then(response => {
				if(response.data.state == 3) {
					this.tit = response.data.title;
					this.list = response.data.list;		
				}
			});
		   
		},
	    methods: {

	    }
	}

</script>
<style scoped >
.activity{
	width: 100%;
	height: auto;
	background: #fff;
	font-family:PingFangSC-Medium;
	font-size:20px;
	color:rgba(0,0,0,0.45);
}
.top{
	width: 1080px;
	margin: 0 auto;
	height:80px ;
	position: relative;
}
.logo{
	width: 211px;
	height: 43px;
	position: absolute;
	top: 16px;
	left: 0;
}
.back{
	position: absolute;
	top: 30px;
	right: 0;
	font-size:14px;
	font-weight:bold;
	color:rgba(128,128,128,1);
	line-height:20px;
}
.center{
	border-top: 1px solid rgba(0,0,0,0);
	box-sizing: border-box;
	width: 100%;
	height: auto;
	background: #f8f8f8;
	/*background:rgba(246,248,249,1);*/
	font-size: 14px;
	padding: 50px 0;
}
.tit{
	height: 60px;
	font-size: 20px;
	text-align: center;
	font-weight: bold;
	color: #005EB3;
}
.con{
	width:1080px;
	height: 600px;
	margin: 0 auto;
	overflow-y: scroll;
}
.con li{
	display: flex;
	justify-content: center;
	align-items: center;
	border-left:1px solid #333;
	border-right:1px solid #333;
	border-bottom:1px solid #333;
}
li a{
	display: flex;
	justify-content: center;
	align-items: stretch;
	width: 100%;
	height: 100%;
}
.con li span{
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 5px 0;
	border-right: 1px solid #333;
}
.con a span:last-child{
	border-right: none;
}
a span:nth-of-type(1){
	width: 50px;
}
a span:nth-of-type(2){
	width: 100px;
}
a span:nth-of-type(3){
	text-align: left;
	width: 190px;
}
a span:nth-of-type(4){
	text-align: left;
	width: 340px;
}
a span:nth-of-type(5){
	width: 130px;
}
a span:nth-of-type(6){
	text-align: left;
	width: 130px;
}

a span:nth-of-type(7){
	text-align: left;
	width: 100px;
}
a span:nth-of-type(8){
	text-align: left;
	width: 120px;
}
.tHead{
	border-top: 1px solid #333;
	font-size: 18px;
	color: #050505;
	background: #d8d8d8;
}
.blue{
	color: #005EB3;
	text-decoration: underline;
}
.color{
	color: #666;
}
</style>



// WEBPACK FOOTER //
// src/components/Activity.vue